import { DepartmentKey } from '~/store/slices/filterSlice'
import { Include, PractitionerStatusDefinition } from '~/storm'
import { isDepartmentIncluded } from '~/utils/surgeryActivities'

import { DatePractitionerCell } from '../../../shared'
import { StatusTag } from './StatusTag'

type Props = {
    statusDefinitions: Include<PractitionerStatusDefinition, { departments: true }>[]
    selectedCells: DatePractitionerCell[]
    departmentKey: DepartmentKey
}

export const StatusDefinitionTags = ({ statusDefinitions, selectedCells, departmentKey }: Props) => (
    <>
        {statusDefinitions.map(({ code, departments }, index) => {
            if (!isDepartmentIncluded(departmentKey, departments)) return null

            return <StatusTag key={code} selectedCells={selectedCells} statusCode={code} autoFocus={index === 0} />
        })}
    </>
)
